module.exports = __webpack_public_path__ + "static/media/RedHatText-Bold.a9bc23f5.ttf";